export default "__VITE_ASSET__CVKuWGLI__"